import React from 'react';
import { Icon } from '../../Icons';
import { ABOUT_INFO } from '../../../utils/constants';
import styles from '../AppContent.module.css';
import localStyles from './AboutMe.module.css';

// GitHub username
const GITHUB_USERNAME = 'IJustWantAJob';

// Social links
const SOCIAL_LINKS = {
  twitter: {
    username: 'adicodemonkey',
    displayName: 'Aditya Kanteti',
    url: 'https://twitter.com/adicodemonkey',
  },
  linkedin: {
    username: 'adityakanteti',
    displayName: 'Aditya Kanteti',
    url: 'https://linkedin.com/in/adityakanteti',
  },
};

const GitHubStatsSection: React.FC = () => {
  return (
    <div className={localStyles.githubStats}>
      <div className={localStyles.contributionGraph}>
        <img
          src={`https://ghchart.rshah.org/${GITHUB_USERNAME}`}
          alt={`${GITHUB_USERNAME}'s GitHub Contribution Graph`}
          style={{ width: '100%', maxWidth: '720px', height: 'auto' }}
        />
      </div>

      <a
        href={`https://github.com/${GITHUB_USERNAME}`}
        target="_blank"
        rel="noopener noreferrer"
        className={localStyles.githubLink}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
        </svg>
        View GitHub Profile
      </a>
    </div>
  );
};

const SocialLinksSection: React.FC = () => {
  return (
    <div className={localStyles.socialLinks}>
      {/* Twitter Card */}
      <a
        href={SOCIAL_LINKS.twitter.url}
        target="_blank"
        rel="noopener noreferrer"
        className={localStyles.socialCard}
      >
        <div className={localStyles.socialCardContent}>
          <div className={localStyles.socialAvatar}>
            <img
              src="/profile-about.jpg"
              alt={SOCIAL_LINKS.twitter.displayName}
              className={localStyles.socialAvatarImg}
            />
          </div>
          <div className={localStyles.socialInfo}>
            <span className={localStyles.socialDisplayName}>{SOCIAL_LINKS.twitter.displayName}</span>
            <span className={localStyles.socialUsername}>@{SOCIAL_LINKS.twitter.username}</span>
          </div>
        </div>
        <div className={localStyles.socialLogo}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </div>
      </a>

      {/* LinkedIn Card */}
      <a
        href={SOCIAL_LINKS.linkedin.url}
        target="_blank"
        rel="noopener noreferrer"
        className={`${localStyles.socialCard} ${localStyles.linkedinCard}`}
      >
        <div className={localStyles.socialCardContent}>
          <div className={localStyles.socialAvatar}>
            <img
              src="/profile-linkedin.jpg"
              alt={SOCIAL_LINKS.linkedin.displayName}
              className={localStyles.socialAvatarImg}
            />
          </div>
          <div className={localStyles.socialInfo}>
            <span className={localStyles.socialDisplayName}>{SOCIAL_LINKS.linkedin.displayName}</span>
            <span className={localStyles.socialUsername}>in/{SOCIAL_LINKS.linkedin.username}</span>
          </div>
        </div>
        <div className={localStyles.socialLogo}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        </div>
      </a>
    </div>
  );
};

export const AboutMe: React.FC = () => {
  return (
    <div className={styles.appContainer}>
      <div className={styles.contentPanel}>
        {/* Header Section */}
        <div className={localStyles.header}>
          <div className={localStyles.avatar}>
            <Icon name="user" size={80} />
          </div>
          <div className={localStyles.headerInfo}>
            <h1 className={localStyles.name}>{ABOUT_INFO.name}</h1>
            <p className={localStyles.title}>{ABOUT_INFO.title}</p>
            <p className={localStyles.location}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" style={{ marginRight: 4 }}>
                <path d="M6 0 C3 0 1 2 1 5 C1 8 6 12 6 12 C6 12 11 8 11 5 C11 2 9 0 6 0 Z M6 7 C4.9 7 4 6.1 4 5 C4 3.9 4.9 3 6 3 C7.1 3 8 3.9 8 5 C8 6.1 7.1 7 6 7 Z"/>
              </svg>
              {ABOUT_INFO.location}
            </p>
          </div>
        </div>

        {/* Bio Section */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>About</h2>
          <div className={localStyles.bio}>
            {ABOUT_INFO.bio.split('\n\n').map((paragraph, index) => (
              <p key={index} className={localStyles.bioParagraph}>
                {paragraph}
              </p>
            ))}
          </div>
        </div>

        {/* GitHub Stats Section */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" style={{ marginRight: 6 }}>
              <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
            </svg>
            GitHub Activity
          </h2>
          <GitHubStatsSection />
        </div>

        {/* Social Links Section */}
        <div className={styles.section}>
          <h2 className={styles.sectionTitle}>Connect With Me</h2>
          <SocialLinksSection />
        </div>

        {/* Contact CTA */}
        <div className={localStyles.contactCta}>
          <p>Interested in working together?</p>
          <span className={styles.link}>Get in touch via the Contact page!</span>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
